import React, { FC, useMemo } from 'react'
import { components } from 'react-select'
import { $TSFixMe } from 'types/ts-migrate'
import { Select } from 'views/components'
import CheckIcon from 'components/atoms/Icons/Controls/Check'
import { filterAgencyOption, sortAgencyOptions, TAgencyOption } from 'utils/agency'
import styles from './AgencySwitcher.module.scss'

export type { TAgencyOption }

const AgencyOption: FC<{ data: TAgencyOption; isDisabled: boolean; innerProps: $TSFixMe }> = props => {
  return !props.isDisabled ? (
    <components.Option {...props} {...props.innerProps}>
      <div className={styles['custom-option']}>
        <span className={styles.check}>
          {props.data.isCurrent && <CheckIcon width={20} height={20} title="Current agency" />}
        </span>
        <div className={styles.details}>
          <strong>{props.data.label}</strong>
          {props.data.companyName && <span className={styles.subtle}>{props.data.companyName}</span>}
          {props.data.role && <span className={styles.role}>{props.data.role}</span>}
        </div>
      </div>
    </components.Option>
  ) : null
}

type AgencySwitcherProps = {
  agencyOptions: TAgencyOption[]
  onAgencySelection: (agency: any) => void
  value?: TAgencyOption
}

const AgencySwitcher: FC<AgencySwitcherProps> = ({ agencyOptions, onAgencySelection, value }) => {
  const sortedOptions = useMemo(() => sortAgencyOptions(agencyOptions), [agencyOptions])

  return (
    <div>
      <Select
        name="agencies"
        label=""
        placeholder="Search agencies"
        options={sortedOptions}
        isSearchable
        filterOption={filterAgencyOption}
        onChange={onAgencySelection}
        components={{ Option: AgencyOption }}
        value={value}
      />
    </div>
  )
}

export default AgencySwitcher
